import Icon1 from "@assets/icons/Icon";
import React from "react";

type CheckBoxInputProps = {
  label?: string;
  checked?: boolean;
  onChange?: (e: any) => void;
  className?: string;
  disabled?: boolean;
};

export default function CheckBoxInput(props: CheckBoxInputProps) {
  return (
    <div
      className={`flex flex-row gap-1 items-center ${props.className || ""}`}
    >
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={props.checked}
          onChange={props.onChange}
          disabled={props.disabled}
          className="sr-only peer" // Cache la checkbox native
        />
        {/* Checkbox personnalisée */}
        <div
          className={`
            hover:ring-2 hover:ring-neutral-300
            w-5 h-5 mr-2
            border-1 border-neutral-300
            rounded-md
            peer-checked:bg-black
            peer-checked:border-black
            peer-disabled:opacity-50 
            peer-disabled:cursor-not-allowed
            transition-all
            flex items-center justify-center
          `}
        >
          {/* Icône de check */}
          {props.checked && (
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M5 13l4 4L19 7"></path>
            </svg>
          )}
        </div>
      </label>
      {props.label && (
        <div
          className={`text-black text-h2
            tx
            select-none cursor-pointer ${
              props.disabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
          onClick={() =>
            !props.disabled &&
            props.onChange?.({ target: { checked: !props.checked } })
          }
        >
          {props.label}
        </div>
      )}
    </div>
  );
}
